export default __webpack_public_path__ + "static/media/Screenshot_17.39286b28.png";